/**
 * Program: validation directive
 * Author: SDL
 * Description: validation directive
 */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
import SDLUtil from '@/utils/SDLUtil';
const checkScopGrid = (field, addYn) => {
  const parent = field.parentElement;
  if (parent) {
    if (parent.classList.contains('scop_grid') || parent.classList.contains('list_table')) {
      if (addYn) parent.classList.add('visible');
      else parent.classList.remove('visible');
      return;
    }
    return checkScopGrid(parent, addYn);
  }
  return null;
}
/**
 * param: field(the element bound with 'v-validation'), msg(error message)
 * return:
 * exception:
 * description: set error message at the element bound with 'v-validation'
 */
const showErrMsg = (field, msg) => {
  const errDiv = document.createElement('div');
  errDiv.innerHTML = SDLUtil.getMsgProp(msg);
  errDiv.className = 'invalid-feedback';
  checkScopGrid(field, true);
  field.classList.add('is-invalid');

  const parent = field.parentNode;
  const children = parent.childNodes;
  let childrenWidthSum = 0;

  // 부모요소의 자식요소가 field 외에 또 존재할 때(label 등) && 부모요소 길이 > field 길이 일 때 width, left 세팅
  if (children.length > 1 && parent.offsetWidth > field.offsetWidth) {
    for (let i = 0; i < children.length; i++) {
      if (children[i].className !== undefined && children[i].className.indexOf('is-invalid') > -1) break; // field 앞 요소들의 길이만 합침
      childrenWidthSum += children[i].offsetWidth !== undefined ? children[i].offsetWidth : 0;
    }
    errDiv.style.width = `${field.offsetWidth}px`;
    errDiv.style.left = `${childrenWidthSum}px`;
  }

  field.insertAdjacentElement('afterend', errDiv);
};
const validationObj = (field, valids) => {

  Array.from(field.parentElement.querySelectorAll('.invalid-feedback')).forEach(el => {
    try {
      checkScopGrid(field, false);
      el.remove();
    } catch (e) {
      checkScopGrid(field, false);
      el.parentNode.removeChild(el);
    }
  });

  if (valids.length > 0) {
    for (let i = 0; i < valids.length; i += 1) {
      if (!valids[i].validFuncs()) {
        showErrMsg(field, valids[i].errorMessage);
        break;
      }
    }
  } else if (field.willValidate && !field.checkValidity()) {
    let errMsg = field.validationMessage;
    if (field.getAttribute('errorMessage')) errMsg = field.getAttribute('errorMessage');

    showErrMsg(field, errMsg);
  }
};

export default {
  bind(el, binding, vnode) {
    let groupId = '';
    let valids = [];
    if (binding.value && Object.prototype.hasOwnProperty.call(binding.value, 'groupId')) {
      groupId = binding.value.groupId;
    }
    if (binding.value && Object.prototype.hasOwnProperty.call(binding.value, 'valids')) {
      valids = binding.value.valids;
    }
    SDLUtil.setValidList({ el, groupId });

    el.setAttribute('required', 'required');
    el.setAttribute('title','');

    if (el.tagName === 'DIV') {
      el.addEventListener('mouseleave', e => {
        e.preventDefault();

        Array.from(document.querySelectorAll('.is-invalid')).forEach(ele => ele.classList.remove('is-invalid'));
        validationObj(el, valids);
      });
      el.addEventListener('mouseenter', e => {
        e.preventDefault();

        el.classList.remove('is-invalid');
      });
    } else {
      ['blur', 'change'].forEach(event => {
        el.addEventListener(event, e => {
          e.preventDefault();

          Array.from(document.querySelectorAll('.is-invalid')).forEach(ele => ele.classList.remove('is-invalid'));
          validationObj(el, valids);
        });
      });
      el.addEventListener('focus', e => {
        e.preventDefault();

        el.classList.remove('is-invalid');
      });
    }
  },
  unbind(el, binding, vnode) {
    let groupId = '';
    if (binding.value && Object.prototype.hasOwnProperty.call(binding.value, 'groupId')) {
      groupId = binding.value.groupId;
    }
    SDLUtil.deleteValidList(el, groupId);
  },
};



// WEBPACK FOOTER //
// ./src/directives/validation.js